import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "replace",
  pure: true,
})
export class ReplacePipe implements PipeTransform {
  public transform(value: string, ...args) {
    return value.replace(args[0], args[1]);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/replace/replace.ts